import { render, staticRenderFns } from "./AdminCourse_edit.vue?vue&type=template&id=5baf1a64&"
import script from "./AdminCourse_edit.vue?vue&type=script&lang=js&"
export * from "./AdminCourse_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports